import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {illustration, contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  
  const ContactIllustration = () => (
    <div style={{
      width: '100%',
      height: '420px',
      backgroundColor: isDark ? '#0f172a' : '#f8fafc',
      border: `2px solid ${isDark ? 'rgba(148,163,184,0.15)' : 'rgba(15,23,42,0.08)'}`,
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      boxShadow: isDark ? '0 24px 48px rgba(0,0,0,0.35)' : '0 24px 48px rgba(2,6,23,0.08)'
    }}>
      {/* Accent gradient blob */}
      <div style={{
        position: 'absolute',
        width: '320px',
        height: '320px',
        right: '-80px',
        top: '-80px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at center, rgba(0,112,243,0.25), rgba(124,58,237,0.15) 60%, transparent 70%)',
        filter: 'blur(12px)'
      }} />
      <div style={{
        position: 'absolute',
        width: '260px',
        height: '260px',
        left: '-60px',
        bottom: '-60px',
        borderRadius: '50%',
        background: 'radial-gradient(circle at center, rgba(6,182,212,0.2), rgba(16,185,129,0.12) 60%, transparent 70%)',
        filter: 'blur(14px)'
      }} />

      {/* Envelope tile */}
      <div style={{
        width: '210px',
        height: '130px',
        background: '#6c63ff',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 12px 30px rgba(108, 99, 255, 0.25)',
        transform: 'rotate(-6deg)'
      }}>
        <div style={{
          width: '180px',
          height: '100px',
          backgroundColor: isDark ? '#111827' : '#ffffff',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '28px',
          color: '#6c63ff',
          border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(2,6,23,0.06)'}`
        }}>
          ✉️
        </div>
      </div>
    </div>
  );

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <div className={isDark ? "dark-mode contact-card" : "contact-card"}>
              <span className="availability-badge">Open to opportunities</span>

              <h3 className="contact-headline">Let’s build something exceptional</h3>
              <p className="contact-copy">
                {contactInfo.subtitle}
              </p>

              <div className="contact-actions">
                <a className="btn primary" href={"mailto:" + contactInfo.email_address}>
                  <i className="fas fa-paper-plane" /> Email me
                </a>
                {contactInfo.number && (
                  <a className="btn secondary" href={"tel:" + contactInfo.number}>
                    <i className="fas fa-phone" /> Call me
                  </a>
                )}
              </div>

              <div className="contact-meta">
                <span className="chip">Response within 24h</span>
                <span className="chip">Remote-friendly</span>
              </div>

              <div className="contact-social-panel">
                <SocialMedia />
              </div>
            </div>
          </div>
          <div className="contact-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={email} />
            ) : (
              <ContactIllustration />
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
